import { Grid } from "@mui/material";
import React from "react";

interface IEditFolderWrapper {
    children: React.ReactNode;
}

function EditFolderWrapper({
    children
}: IEditFolderWrapper) {
    return (
        <Grid
            container
        >
            { children }
        </Grid>
    );
}

export default EditFolderWrapper;